var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('tit', {
    staticClass: "tit--lg white--text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("당신의 새로운 시작에 함께 하겠습니다. ")])]), _c('span', {
    staticClass: "line my-12px my-md-24px",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _c('txt', {
    staticClass: "white--text line-height-17",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('p', {
    staticClass: "mb-12px mb-md-24px"
  }, [_vm._v("안녕하세요. 이혼전문변호사 문종하입니다.")]), _c('p', [_vm._v("언제나 의뢰인의 이야기에 귀를 기울이고 전문적인 도움을 드리겠습니다. 이혼소송은 각자의 상황에 맞는 해결책이 필요한 만큼 의뢰인의 상황에 적합한 최상의 결과를 만들어 드리겠습니다. 어렵고 힘든 시간을 지나 새로운 시작에 힘이 되어 드리겠습니다.")])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }